import * as React from "react";
import { Route, Switch } from "wouter";

import { BidNoBidReport } from "./qualification_report_section/BidNoBidReport";
import { BidDocumentUploadPage } from "./BidDocumentUploadPage";

type NoticeProps = {
  from: "noticePage";
  noticeId: string;
  procurementStageId: string;
  noticeTitle: string;
  buyerName: string;
  buyerId: string;
};

type OppsProps = {
  from: "opportunityPage";
  opportunityId: string;
};

type Props = NoticeProps | OppsProps;

export function BidNoBidPage(props: Props) {
  // TODO: This is temporary. Just here to handle any legacy bid links (like ones that are shared)
  if (props.from === "noticePage") {
    return (
      <Switch>
        {/* Deleting the BidDocumentUploadPage route because a user shouldn't be able to create new bids from notice details anymore*/}
        <Route path={`/bid_qualification/:bidId`}>
          {({ bidId }) => <BidNoBidReport bidId={bidId} />}
        </Route>
      </Switch>
    );
  }

  if (props.from === "opportunityPage") {
    return (
      <Switch>
        <Route path="/:id/bid_qualification">
          <BidDocumentUploadPage opportunityId={props.opportunityId} />
        </Route>
        <Route path={`/:id/bid_qualification/:bidId`}>
          {({ id, bidId }) => <BidNoBidReport bidId={bidId} opportunityId={id} />}
        </Route>
      </Switch>
    );
  }

  return null;
}
